<template>
  <div :class="{
    block: block,
    'w-full': full,
  }">
    <div class="flex">
      <Label
        :variant="InputLabelVariantCombination[variant].label"
        :size="size"
        v-if="label"
      >{{ label }}</Label>
      <span class="text-xs text-gray-400 p-1 flex flex-col justify-end" v-show="tag">{{ tag }}</span>
    </div>

    <TextArea
      :modelValue="modelValue"
      @update:modelValue="updateText"
      :rows="rows"
      :full="full"
      :required="required"
      :placeholder="placeholder"
    />
  </div>
</template>

<script setup lang="ts">
//Components
import Label from "@/components/atoms/BaseLabel.vue";
import TextArea from "@/components/atoms/BaseTextArea.vue";

//Types
import type { SizesKeysType } from "@/types/sizes.type";

//Component types & definitions
import {
  VariantKeys as InputLabelVariantKeys,
  VariantsType as InputLabelVariantKeysType,
  variantCombination as InputLabelVariantCombination,
} from "@/components/molecules/inputLabel/InputLabel";

withDefaults(
  defineProps<{
    modelValue?: string;
    variant?: InputLabelVariantKeysType;
    size?: SizesKeysType;
    block?: boolean;
    full?: boolean;
    label?: string | undefined;
    tag?: string | undefined;
    placeholder?: string | undefined;
    required?: boolean;
    rows?: number;
  }>(),
  {
    modelValue: "",
    variant: InputLabelVariantKeys.primary,
    block: false,
    full: true,
    label: undefined,
    tag: undefined,
  }
);

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const updateText = (textValue: string) => emit("update:modelValue", textValue)

</script>
